import { build } from "../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/profile/history",
	lazy(() => import("./AllHistoryPage"))
);
